import axios from 'axios';

import cfac22 from '../cfac22';

export async function getStoreItem(storeId) {
  return new Promise((resolve, reject) => {
    Promise.resolve()
      .then(() => {
        const config = {
          method: 'post',
          url: cfac22('API_HOST_V2') + '/stores/getStoreItem',
          headers: {
            'Full-Url': window.location.href,
          },
          data: { storeId, partnerId: cfac22('partnerId') },
          withCredentials: true,
        };

        axios(config)
          .then(function (response) {
            resolve(response.data.response);
          })
          .catch(function (error) {
            reject(error.response.data);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

